// Laying a session on a board from one of its cells, asked from outside the
// board (a lanes view's own dock, reading a cell of the board's anchor): the
// board lands it where it can be seen to come from (SessionCanvasView). A
// board that is up answers; one that is not lets the ask go.
// `land({ from: { key, lane, turn }, sid, title, startMs, follow, cellsOf })`,
// `key` null for the board's own trace.
export function createBoardLanding() {
  let answer = null;
  return {
    attach: (fn) => {
      answer = fn;
      return () => { if (answer === fn) answer = null; };
    },
    land: (req) => answer?.(req),
  };
}
